import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  FormField,
  TextInput,
  Select,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import { Calendar } from '../../../reusable-components/calendar/calendar';
import {
  isEmpty,
  isNoSpace,
  isNotEmpty,
  isValidLastName,
  onlyCharacters,
} from '../../../helpers/helpers';
import useCobStore from '../../../../store/cob-store';
import { COBLayout } from '../../../cob-layout/cob-layout';
// import { AdditionalInfo } from '../../../../types/online-forms.types';

export function PolicyDetails(props: any) {
  const { nextButtonClicked, errorHandling, OPISResponseInfo, nextDisabled } =
    props;
  // const [ setOPISResponseInfo ] = useState(Array<any>);
  const is360 = useMediaQuery(queryHelpers.down(390));

  // const updateCobInfo = useCobStore((state: any) => state.updateCobInfo);
  const cobInformation = useCobStore((state: any) => state.cobInformation);
  const dependantList = useCobStore((state: any) => state.demographics);
  // if(OPISResponseInfo !== undefined) {
  //   // sessionStorage({OPISResponseInfo: OPISResponseInfo})
  //   sessionStorage.setItem(OPISResponseInfo, OPISResponseInfo);
  // }
  // const [relationShip, setRelationShip] = useState('');
  const relations =
    COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.RELATIONSHIPLIST;
  let relationsList = [];

  const [form, setForm] = useState({
    relationshipToSubscriber: OPISResponseInfo?.relationshipToSubscriber
      ? OPISResponseInfo?.relationshipToSubscriber
      : '1',
    firstName: OPISResponseInfo?.subscriber?.member?.firstName
      ? OPISResponseInfo?.subscriber?.member?.firstName
      : '',
    lastName: OPISResponseInfo?.subscriber?.member?.lastName
      ? OPISResponseInfo?.subscriber?.member?.lastName
      : '',
    dateOfBirth: OPISResponseInfo?.subscriber?.member?.dateOfBirth
      ? OPISResponseInfo?.subscriber?.member?.dateOfBirth
      : '',
  });

  const [errors, setErrors] = useState({
    relationshipToSubscriber: false,
    firstName: false,
    lastName: false,
    dateOfBirth: false,
  });

  useEffect(() => {
    if (
      form.relationshipToSubscriber === '' ||
      form.relationshipToSubscriber !== ''
    ) {
      nextDisabled(false);
    } else {
      nextDisabled(true);
    }
  }, [nextDisabled, form.relationshipToSubscriber]);

  const formField =
    isEmpty(form.relationshipToSubscriber) ||
    isEmpty(form.firstName) ||
    isEmpty(form.lastName) ||
    isEmpty(form.dateOfBirth);

  const isValid =
    isNotEmpty(form.relationshipToSubscriber) &&
    isNotEmpty(form.firstName) &&
    isNotEmpty(form.lastName) &&
    isNotEmpty(form.dateOfBirth);
  const updatePolicyDetail = () => {
    const filterInfo = cobInformation.additionalInsurance.filter(
      (memberDetail: any) =>
        memberDetail.member.firstName === OPISResponseInfo.member.firstName &&
        memberDetail.member.lastName === OPISResponseInfo.member.lastName,
    );
    return filterInfo[0];
  };

  const onUpdateField = (event: any) => {
    const { value, id } = event.target ? event.target : event;
    const nextFormState = {
      ...form,
      [id]: value,
    };
    const policyUpdate = updatePolicyDetail();
    policyUpdate.relationshipToSubscriber =
      nextFormState.relationshipToSubscriber;
    policyUpdate.subscriber.member.firstName = nextFormState.firstName;
    policyUpdate.subscriber.member.lastName = nextFormState.lastName;
    policyUpdate.subscriber.member.dateOfBirth = nextFormState.dateOfBirth;

    // if (policyUpdate) {
    //   // updateCobInfo(OPISResponseInfo, nextFormState);
    // }
    setForm(nextFormState);
    if (id === 'firstName') {
      setForm((prevState) => ({
        ...prevState,
        firstName: isNoSpace(value)
          ? ''
          : onlyCharacters(value.replace(/^\s+/g, '')),
      }));
    }
    if (id === 'lastName') {
      setForm((prevState) => ({
        ...prevState,
        lastName: isNoSpace(value)
          ? ''
          : isValidLastName(value.replace(/^\s+/g, '')),
      }));
    }
    setErrors({
      ...errors,
      [id]: isEmpty(value.trim()),
    });
  };

  const selectedDateOfBirth = (selectedDate: string) => {
    onUpdateField({ value: selectedDate, id: 'dateOfBirth' });
  };

  const relationshipList = () => {
    const relationList = [];
    // eslint-disable-next-line no-plusplus

    for (let i = 0; i < relations.length; i += 1) {
      relationList.push({
        key: i.toString(),
        value: (i + 1).toString(),
        label: relations[i],
      });
    }
    return relationList;
  };
  relationsList = relationshipList();

  useEffect(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, form, errors, OPISResponseInfo, errorHandling]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          relationshipToSubscriber: isEmpty(form.relationshipToSubscriber),
          firstName: isEmpty(form.firstName),
          lastName: isEmpty(form.lastName),
          dateOfBirth: isEmpty(form.dateOfBirth),
        });
      }
    }
  }, [
    nextButtonClicked,
    isValid,
    form.relationshipToSubscriber,
    form.firstName,
    form.lastName,
    form.dateOfBirth,
  ]);

  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList.demographics?.firstName &&
        OPISResponseInfo.member?.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOUROTHERINSURANCE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTOTHERINSURANCE}`}`
      }
      dataTestId="policyDetails"
      questionTitle={
        OPISResponseInfo?.member?.firstName ===
        dependantList.demographics?.firstName
          ? COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.TELLUSABOUT
          : `${`${COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.TITLE} ${OPISResponseInfo.member.firstName}${COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.CONTINUETITLE}`}`
      }
      disclaimer={COBQuestioner.COB.QUESTIONS.REQUIREDDISCLAIMER}
      isDependant={false}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <FormField
          id="relationshipToSubscriber"
          label={COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.RELATIONSHIP}
          aria-label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.RELATIONSHIP
          }
          hideLabel={{ '@initial': false, '@tablet': true }}
          statusIconLabel="Error"
          inputStatus={errors.relationshipToSubscriber ? 'error' : undefined}
          statusMessage={
            errors.relationshipToSubscriber
              ? COBQuestioner.COB.ERRORS.RELATIONSHIP
              : ''
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <Select
            options={relationsList}
            name="relationship"
            aria-label="Relationship to Other Insurance policyholder"
            value={OPISResponseInfo?.relationshipToSubscriber}
            onChange={onUpdateField}
          />
        </FormField>
        <FormField
          id="firstName"
          label={COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.FIRSTNAME}
          statusIconLabel="Error"
          inputStatus={errors.firstName ? 'error' : undefined}
          statusMessage={
            errors.firstName ? COBQuestioner.COB.ERRORS.FIRSTNAME : ''
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            value={form?.firstName}
            maxLength={25}
            onChange={onUpdateField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.PLACEHOLDER
                .FIRSTNAME
            }
          />
        </FormField>
        <FormField
          id="lastName"
          label={COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.LASTNAME}
          statusIconLabel="Error"
          inputStatus={errors.lastName ? 'error' : undefined}
          statusMessage={
            errors.lastName ? COBQuestioner.COB.ERRORS.LASTNAME : ''
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            value={form?.lastName}
            maxLength={35}
            onChange={onUpdateField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.PLACEHOLDER
                .LASTNAME
            }
          />
        </FormField>
        <FormField
          id="dateOfBirth"
          label={COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.DOB}
          aria-label={COBQuestioner.COB.QUESTIONS.CONTROLS.POLICYHOLDER.DOB}
          statusIconLabel="Error"
          css={
            {
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <Calendar
            selectedFormatDate={selectedDateOfBirth}
            currentDate={`${OPISResponseInfo?.subscriber?.member.dateOfBirth}`}
            showError={errors.dateOfBirth}
            errorMessage={COBQuestioner.COB.ERRORS.REQUIREDDOB}
            isFutureLimitYear
            setWidth={`${!is360 ? '116px' : '105px'}`}
          />
        </FormField>
      </Box>
    </COBLayout>
  );
}
